import classNames from 'classnames'
import React from 'react'

import { CustomAvatar } from './avatar'

export const DetailedAvatar = ({ title, subtitle, className, ...props }) => {
  const classes = classNames('detailed-avatar-container', className)
  return (
    <div className={classes}>
      <CustomAvatar name={title} size="large" {...props} />
      <div className="avatar-details">
        <div className="avatar-title">{title}</div>
        <div className="avatar-subtitle">{subtitle}</div>
      </div>
    </div>
  )
}
